type ConfigObject = { [key: string]: string };

export function transformKeysToSnakeCase(data: ConfigObject): ConfigObject {
  const transformedObject: ConfigObject = {};

  for (const key in data) {
    if (data.hasOwnProperty(key)) {
      const snakeCaseKey = key.replace(/([A-Z])/g, '_$1').toLowerCase();
      transformedObject[snakeCaseKey] = data[key];
    }
  }

  return transformedObject;
}

type GetSearchParamsOptions = {
  localStorageKey?: string;
  defaultValue?: string;
};

export const getSearchParams = (key: string, options: GetSearchParamsOptions = {}): string | null => {
  const { localStorageKey, defaultValue } = options;

  const searchParams = new URLSearchParams(window.location.search);
  const fromQuery = searchParams.get(key);

  if (fromQuery !== null) {
    return fromQuery;
  }

  if (localStorageKey) {
    const fromStorage = localStorage.getItem(localStorageKey);
    if (fromStorage !== null) {
      return fromStorage;
    }
  }

  return defaultValue ?? null;
};
